import { getDateTimePreferences, isoDateInTimeZone } from '@multaqa/i18n'

/** Return a browser-local Date carrying a company-local calendar date. */
export function companyDateOffset(timezone: string, offsetDays: number, now = new Date()): Date {
  const parts = Object.fromEntries(
    new Intl.DateTimeFormat('en', {
      timeZone: timezone,
      calendar: 'gregory',
      numberingSystem: 'latn',
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
    })
      .formatToParts(now)
      .map(({ type, value }) => [type, value]),
  )

  return new Date(Number(parts.year), Number(parts.month) - 1, Number(parts.day) + offsetDays, 12)
}

/** Today in the active company's configured date-time zone, or the browser zone. */
export function companyTodayIsoDate(timeZone?: string | null, now = new Date()): string {
  const activeTimeZone = timeZone || getDateTimePreferences().timeZone
  return isoDateInTimeZone(now, activeTimeZone)
}

/** Preserve a calendar date represented by a local-midnight Date. */
export function localIsoDate(value: Date): string {
  const year = String(value.getFullYear()).padStart(4, '0')
  const month = String(value.getMonth() + 1).padStart(2, '0')
  const day = String(value.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

/** Add calendar days to a picked YYYY-MM-DD value without interpreting it as UTC. */
export function addIsoDateDays(value: string, days: number): string {
  const [year = 0, month = 1, day = 1] = value.split('-').map(Number)
  return localIsoDate(new Date(year, month - 1, day + days))
}
